import { normalizeParkingVisits, parkingTicketTypes } from "../model/parkingVisitAdapter";
import axiosInstance from "core/api/axiosInstance";
import { ticketValue, validateFrequencyFilters } from "../model/frequencyModel";
export { processPermanenceData } from "../model/permanenceModel";
export async function getPermanenceService(params, signal) {
  try {
    const invalid = validateFrequencyFilters(params);
    if (invalid) throw new Error(invalid);
    const endpoint = process.env.REACT_APP_PERMANENCIA_API_URL || "/api/isrr/get-frecuency";
    const query = new URLSearchParams({
      startDate: params.startDate,
      endDate: params.endDate,
      startAt: `${params.startDate}T00:00:00-05:00`,
      endAt: `${params.endDate}T23:59:59.999-05:00`,
      timeZone: "America/Bogota",
      dateBasis: "exit",
    });
    const selected = (params.ticketTypes || []).map(ticketValue).filter(Boolean);
    if (selected.length) query.set("ticketTypes", JSON.stringify(selected));
    const { data } = await axiosInstance.get(
      `${endpoint}${endpoint.includes("?") ? "&" : "?"}${query}`,
      { signal }
    );
    if (!Array.isArray(data?.data) || (data.code !== undefined && data.code !== 0))
      throw new Error(data?.message || "El servidor no devolvió una lista de visitas válida.");
    if (
      data.pagination?.hasMore ||
      (Number.isFinite(Number(data.count)) && Number(data.count) > data.data.length)
    )
      throw new Error(
        "El informe recibido está incompleto. Se requieren todas las visitas del rango."
      );
    return {
      success: true,
      data: normalizeParkingVisits(data.data),
      ticketTypes: [
        ...(Array.isArray(data.ticket_types) ? data.ticket_types : []),
        ...parkingTicketTypes(data.data),
      ],
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "No se pudo consultar permanencia.",
      isCanceled: signal?.aborted || error.code === "ERR_CANCELED",
    };
  }
}
